import { render, staticRenderFns } from "./StudentAnalytics.vue?vue&type=template&id=1299cb0a"
import script from "./StudentAnalytics.vue?vue&type=script&lang=js"
export * from "./StudentAnalytics.vue?vue&type=script&lang=js"
import style0 from "./StudentAnalytics.vue?vue&type=style&index=0&id=1299cb0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports